import ActionsBuilder from '../../../../utils/actions/ActionsBuilder';

export const IDENTIFIER = '[INDUSTRIES]';
export default ActionsBuilder.buildList(IDENTIFIER);
